<template>
  <div>
    <CRow class="content-fade-in">
      <CCol md="12">
        <CCard>
          <CCardBody>
            <CForm class="form-basic">
              <CRow>
                <CCol sm="12" md="6" xl="6">
                  <BaseInput
                    :options="codeInput.options"
                    :data="codeInput.data"
                  />
             
                </CCol>

                <CCol sm="12" md="6" xl="6">
                    <BaseInput
                        :options="nameInput.options"
                        :data="nameInput.data"
                    />
                </CCol>

                <CCol sm="12" md="6" xl="6">
                    <BaseInput
                    :options="fromDate.options"
                    :data="fromDate.data"
                  />
                </CCol>

                <CCol sm="12" md="6" xl="6">
                  
                  <BaseInput
                    :options="toDate.options"
                    :data="toDate.data"
                  />
                </CCol>

                <CCol sm="12" md="6" xl="6">
                    <BaseInput
                        :options="discountInput.options"
                        :data="discountInput.data"
                    />
                </CCol>

                <!-- <CCol sm="12" md="6" xl="6">
                    <BaseSelect
                        :options="isActiveSelect.options"
                        :data="isActiveSelect.data"
                        ref="isActive"
                    >
                    </BaseSelect>
                </CCol> -->
                 
              </CRow>
              <div slot="footer" class="mt-4">
                <CButton
                  color="primary"
                  class="btn-action-primary mr-2"
                  @click="submitData"
                >
                  <i class="fa fa-plus"></i> Thêm mới
                </CButton
                >
                <CButton
                  color="secondary"
                  class="btn-action-primary"
                  @click="$router.go(-1)"
                ><i class="fa fa-reply"></i> Hủy bỏ
                </CButton>
              </div>
              <BaseLoading :loading="loading.value"></BaseLoading>
            </CForm>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import BaseSelect from "../base/BaseSelect2";
import BaseInput from "../base/BaseInput";
import BaseLoading from "../base/BaseFormLoading";

export default {
  name: "SaleProgramAdd",
  components: {BaseSelect, BaseInput, BaseLoading},
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Errors"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  data: function () {
    let that = this;
    return {
      loading: {value: false},
      codeInput: {
        options: {
          label: "Mã chương trình khuyến mại *",
          placeholder: "Mã chương trình khuyến mại",
          type: "text",
          maxlength: 100
        },
        data: {
          name: "code",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.codeInput.data.model;
              if (value === "" || value === null) {
                this.isValid = false;
                this.errorMessage = "Mã chương trình khuyến mại không được để trống";
              } else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          }
        }
      },
      nameInput: {
        options: {
          label: "Tên chương trình khuyến mại *",
          placeholder: "Tên chương trình khuyến mại",
          type: "text",
          maxlength: 200
        },
        data: {
          name: "name",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.nameInput.data.model;
              if (value === "" || value === null) {
                this.isValid = false;
                this.errorMessage = "Tên chương trình khuyến mại không được để trống";
              } else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          }
        }
      },
      discountInput: {
        options: {
          label: "Khuyến mại (%) *",
          placeholder: "Khuyến mại (%)",
          type: "number",
          maxlength: 200
        },
        data: {
          name: "discount",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.discountInput.data.model;
              if (value === "" || value === null || value == 0) {
                this.isValid = false;
                this.errorMessage = "Khuyến mại (%) không được để trống";
              } else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          }
        }
      },
      fromDate: {
        options: {
          label: "Từ ngày *",
          type: "date",
          maxlength: 200
        },
        data: {
          name: "fromDate",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.fromDate.data.model;
              if (value === "" || value === null) {
                this.isValid = false;
                this.errorMessage = "Từ ngày không được để trống";
              } else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          }
        }
      },
      toDate: {
        options: {
          label: "Đến ngày *",
          type: "date",
          maxlength: 200
        },
        data: {
          name: "toDate",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.toDate.data.model;
              if (value === "" || value === null) {
                this.isValid = false;
                this.errorMessage = "Đến ngày không được để trống";
              } else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          }
        }
      },
      isActiveSelect: {
        options: {
          filter: false,
          label: 'Trạng thái',
        },
        data: {
          name: "active",
          items: [
            {key: "true", value: "Hoạt động"},
            {key: "false", value: "Không hoạt động"},
          ],
          model: 'true'
        }
      }
    };
  },
  methods: {
    submitData: function () {
      let that = this;
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/sale-program/createSaleProgram",
        dataRef: function () {
          return that.$data;
        },
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({message: that.$helper.getStringError(response.data.data)});
            that.$helper.setupErrorModel(response.data.data, that.$data);
          } else {
            that.showSuccessMsg({message: "Thêm mới chương trình khuyến mại thành công"});
            that.$router.push("/sale-program-management/update/"+response.data.data.data.id);
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
  },
  computed: {
  },
  created() {
    
  },
  mounted() {
    
  },
  watch: {}
};
</script>
